import React from 'react';
import { BagIconSmall as HmIconSmall, BagIconMedium as HmIconMedium, BagIcon as HmIcon, } from '../brand/hm/BagIcon';
import { BagIconSmall as HmGroupIconSmall, BagIconMedium as HmGroupIconMedium, BagIcon as HmGroupIcon, } from '../brand/hmGroup/BagIcon';
import { BagIconSmall as MonkiIconSmall, BagIconMedium as MonkiIconMedium, BagIcon as MonkiIcon, } from '../brand/monki/BagIcon';
import { BagIconSmall as NorthstarIconSmall, BagIconMedium as NorthstarIconMedium, BagIcon as NorthstarIcon, } from '../brand/northstar/BagIcon';
import { BagIconSmall as OSIconSmall, BagIconMedium as OSIconMedium, BagIcon as OSIcon, } from '../brand/otherStories/BagIcon';
export const BagIconSmall = (props) => {
    switch (process.env.BRAND) {
        case 'hmGroup':
            return React.createElement(HmGroupIconSmall, { ...props });
        case 'monki':
            return React.createElement(MonkiIconSmall, { ...props });
        case 'northstar':
            return React.createElement(NorthstarIconSmall, { ...props });
        case 'otherStories':
            return React.createElement(OSIconSmall, { ...props });
        case 'hm':
        default:
            return React.createElement(HmIconSmall, { ...props });
    }
};
export const BagIconMedium = (props) => {
    switch (process.env.BRAND) {
        case 'hmGroup':
            return React.createElement(HmGroupIconMedium, { ...props });
        case 'monki':
            return React.createElement(MonkiIconMedium, { ...props });
        case 'northstar':
            return React.createElement(NorthstarIconMedium, { ...props });
        case 'otherStories':
            return React.createElement(OSIconMedium, { ...props });
        case 'hm':
        default:
            return React.createElement(HmIconMedium, { ...props });
    }
};
export const BagIcon = (props) => {
    switch (process.env.BRAND) {
        case 'hmGroup':
            return React.createElement(HmGroupIcon, { ...props });
        case 'monki':
            return React.createElement(MonkiIcon, { ...props });
        case 'northstar':
            return React.createElement(NorthstarIcon, { ...props });
        case 'otherStories':
            return React.createElement(OSIcon, { ...props });
        case 'hm':
        default:
            return React.createElement(HmIcon, { ...props });
    }
};
export default BagIcon;
//# sourceMappingURL=BagIcon.js.map